import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Mixpanel } from "../../helpers/mixpanel";

function ExitIntent() {
  const [showPopup, setShowPopup] = useState(false);
  const [hasShown, setHasShown] = useState(false);

  useEffect(() => {
    const alreadyShown = sessionStorage.getItem("exitIntentShown");
    if (alreadyShown) {
      setHasShown(true);
      return;
    }

    const handleMouseLeave = (e) => {
      if (e.clientY < 10 && !hasShown) {
        setShowPopup(true);
        setHasShown(true);
        sessionStorage.setItem("exitIntentShown", "true");
        Mixpanel.track("EXIT INTENT POPUP SHOWN");
      }
    };

    const timer = setTimeout(() => {
      document.addEventListener("mouseleave", handleMouseLeave);
    }, 3000);

    return () => {
      clearTimeout(timer);
      document.removeEventListener("mouseleave", handleMouseLeave);
    };
  }, [hasShown]);

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full p-8 text-center relative">
        <button
          onClick={() => setShowPopup(false)}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 text-2xl leading-none"
        >
          ×
        </button>

        <div className="text-6xl mb-4">🎁</div>

        <h2 className="text-2xl md:text-3xl font-bold text-dark mb-3">
          Wait! Don't miss your
          <br />
          <span className="text-orange">$25 Amazon Credit</span>
        </h2>

        <p className="text-lightgray mb-6">
          Get a <strong>$25 Amazon credit</strong> just for completing a
          quote. Takes less than 60 seconds!
        </p>

        <div className="bg-blue bg-opacity-10 rounded-lg p-4 mb-6">
          <p className="text-sm text-blue font-semibold">
            🔥 BONUS: Sign up this week = <strong>1st Month FREE</strong>
          </p>
        </div>

        <Link to="/app/pick-mechanism">
          <button
            onClick={() => {
              Mixpanel.track("EXIT INTENT CTA CLICKED");
              setShowPopup(false);
            }}
            className="w-full bg-orange hover:bg-opacity-90 text-dark font-bold py-4 px-8 rounded-full text-lg transition-all transform hover:scale-105"
          >
            CLAIM YOUR $25 CREDIT →
          </button>
        </Link>

        <p className="text-xs text-gray-400 mt-4">
          No purchase required. Valid business address needed.
        </p>
      </div>
    </div>
  );
}

export default ExitIntent;
